import ShouldRenderOffscreen from './types';

const shouldRenderOffscreen: ShouldRenderOffscreen = false;

export default shouldRenderOffscreen;
